const utils         = require('frontend-controller/lib/utils')
const componentList = require('frontend-controller/lib/componentList')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'tabStrip',
        'tabStrip',
    ],

    config: {
        staticLookupName: 'mainNav',
        isMainNav: true,
        limitTabsToNavCode: {
            // officeMainTabs: true,
            // officeSubTabs: false,

            // crewMainTabs: true,
            // customersMainTabs: true,
            // contractorsMainTabs: true,
        }
    },

    model: {
        mainTabAliasData: {}
    },

    methods: {
        sanitizeResources(storage){
            if(storage.isClient) return;

            for(const element of this.resourceData.data || []){
                let actionGranted = utils.isEmpty(this.config.limitTabsToNavCode)
                let showInMainMenu = false
                for(const limitTabsToNavCode in this.config.limitTabsToNavCode || {}){
                    if((element.navs || {})[limitTabsToNavCode]){
                        actionGranted = true
                        showInMainMenu = this.config.limitTabsToNavCode[limitTabsToNavCode]
                        break;
                    }
                }
                if(actionGranted){
                    const attributes    = element.attributes || {}
                    const config        = attributes.config || {}
                    const tabOptions    = config.tabOptions || {}
                    if(attributes.routeID && attributes.path && attributes.name) {
                        const action = this.actions[`addTabForRoute_${tabOptions.navKey || attributes.routeID}`] = utils.simpleMerge(this.actions.addTabForRoute, {
                            isNavRouteTabAction: true,
                            source: {
                                tab: {
                                    componentData: {
                                        resourceData: {
                                            routeID:    attributes.routeID,
                                            path:       attributes.path,
                                            title:      attributes.name,
                                            colors:     tabOptions.colors,
                                            icon:       tabOptions.icon,
                                            aliasIcon:  tabOptions.aliasIcon,
                                            navKey:     showInMainMenu ? tabOptions.navKey : undefined,
                                            grantAutoFocus: showInMainMenu ? !!tabOptions.isDefault : true,
                                        },
                                        config: {
                                            lastMileSelector: showInMainMenu ? '.mainTabs' : undefined,
                                            isMainTab: showInMainMenu,
                                        }
                                    }
                                },
                                tabContent: {
                                    componentRoute: attributes.path
                                }
                            }
                        })

                        componentList.prepareAction(this, action);
                    }
                }
            }
        },

        extendTabsByNav(storage){
            const tabPromises = []

            this.config.closableTabs = false

            for(const actionName in this.actions){
                const action = this.actions[actionName] || {}
                if(action.isNavRouteTabAction && ((((action.source || {}).tab || {}).componentData || {}).config || {}).isMainTab){
                    tabPromises.push(this.performAndStoreAction(
                        `${actionName}_inEffect`,
                        this.prepareAction(actionName),
                        false
                    ))
                }
            }

            this.config.closableTabs = true

            return utils.promise.resolveAll(this, tabPromises)
        },

        navToList(navKey){
            const baseActionKey = `addTabForRoute_${navKey}`
            if(this.actions[baseActionKey]){
                const actionKey = `${baseActionKey}_inEffect`

                if(this.actions[actionKey]){
                    return this.performAction(actionKey)
                } else {
                    return this.performAndStoreAction(
                        actionKey,
                        this.prepareAction(baseActionKey),
                        false
                    )
                }
            }

            return utils.promise.resolve()
        },

        getTabByNavKey(navKey){
            const actionKey = `addTabForRoute_${navKey || 'NO_NAV_KEY'}_inEffect`
            const registerSecret = (((((this.actions[actionKey] || {}).source || {}).tab || {}).componentData || {}).config || {}).registerSecret
            if (registerSecret !== undefined && (this.registry[registerSecret] || {}).tab){
                return this.registry[registerSecret].tab
            }
        },

        onBeforeFocus(registerSecret, registryEntry){
            if(registerSecret !== undefined && (((registryEntry || {}).tab || {}).config || {}).isMainTab){
                this.model.lastSeenMainRegisterSecret = registerSecret
            }
        },

        sanitizeSortedRegisterSecrets(listOfRegisterSecrets){
            if(this.model.lastSeenMainRegisterSecret !== undefined){
                const mainTabRegisterSecrets = []
                utils.forEachReverse(listOfRegisterSecrets, (registerSecret, registerSecretIndex) => {
                    const isMainTab = (((this.registry[registerSecret] || {}).tab || {}).config || {}).isMainTab
                    if(isMainTab){
                        if(this.model.lastSeenMainRegisterSecret != registerSecret){
                            mainTabRegisterSecrets.unshift(registerSecret)
                        }
                        listOfRegisterSecrets.splice(registerSecretIndex, 1)
                    }
                })

                if(this.model.lastSeenMainRegisterSecret !== undefined){
                    mainTabRegisterSecrets.push(this.model.lastSeenMainRegisterSecret)
                }

                if(mainTabRegisterSecrets.length > 0){
                    listOfRegisterSecrets = mainTabRegisterSecrets.concat(listOfRegisterSecrets)
                }
            }
            return listOfRegisterSecrets
        },

        onTabRemoved(registerSecret){
            if(registerSecret !== undefined && registerSecret === this.model.lastSeenMainRegisterSecret){
                delete this.model.lastSeenMainRegisterSecret
            }
        },
    },

    hooks: {
        async _attach($element, options){
            if(!options.refresh){

                // NOTE: storage.request would be overwritten after extendTabsByNav() since these will be loaded via route as well.
                const {
                    p,  // projectID for autoOpen in viewer
                    pt, // projectTermID for autoOpen in viewer
                } = (((window.storage || {}).request || {}).queryParams || {})

                await this.extendTabsByNav()

                if(p && pt){
                    // hide ugly params.
                    window.history.replaceState('', '', '/')
                    await getComponent('projectViewer').show(p, pt)
                    await this.navToList('projects')
                }
            }
        }
    },

    handlers: [
        {
            name: 'onSuccessfulLoginDialog',
            handle: function(callerComponent){
                this.refresh(false)
            }
        },
        {
            name: 'onTabActivate',
            componentClass: 'templates_core_tabStrip_tab',
            handle: function(callerComponent){
                if(callerComponent.config.isMainTab){
                    // save data for mainTabAlias in case of tabStrip refreshes
                    this.model.mainTabAliasData = {
                        colors: callerComponent.resourceData.colors || {},
                        icon: callerComponent.resourceData.aliasIcon || callerComponent.resourceData.icon || '',
                        registerSecret: callerComponent.config.registerSecret,
                    }
                }
            }
        },
    ],
}